<template lang="pug">
  .days
    .day(v-for="(day, index) in days",
        :class="{'gray': index % 2 === 0, 'is-today': day.is_today === true}")
      .date {{ day.date | moment('dd. Do MMM ')}}
      .events
        .event(v-for="event in day.events")
          dl
            dt {{ event.badge }}
            dd {{ event.start | moment('HH:mm') }} - {{ event.name }}
      .production-managers(v-if="day.production_managers.length > 0")
        span.manager-label PL: &nbsp;
        span.manager(v-for="manager in day.production_managers") {{ manager }}
      .day-managers(v-if="day.day_managers.length > 0")
        span.manager-label TL: &nbsp;
        span.manager(v-for="manager in day.day_managers") {{ manager }}
      .managers(v-if="day.managers.length > 0")
        span.manager-label AL: &nbsp;
        span.manager(v-for="manager in day.managers") {{ manager }}

      shift(v-for="(shift, index) in day.my_shifts", :shift="shift",
        :key="shift.id", :class="{'gray': index % 2 === 0}")

      // Tagesuebersicht
      .field(v-if="day.other_shifts.length > 0 || day.documents.length > 0 || (day.schedule && day.schedule !== '')")

        .button-div
          a.button(@click="toggleOtherShifts(day)") Tagesübersicht

        // day schedule
        .schedule(v-if="day.schedule && day.schedule !== ''" v-show="day.show_others")
          h3 Tagesablauf
          p(v-html="$options.filters.linebreaks(day.schedule)")

        // dokumente
        .documents(v-if="day.documents.length > 0" v-show="day.show_others")
          h3 Dokumente
          ul.files
            li(v-for="doc in day.documents")
              a(:href="doc.url", target="_blank")
                i.fa(:class="doc.icon")
                |  {{ doc.name }}

        .other-shifts(v-if="day.show_others")
          shift(v-for="(shift, index) in day.other_shifts", :shift="shift",
            :key="shift.id", :class="{'gray': index % 2 === 0}")

    div(v-if="days.length == 0")
      br
      br
      span Du bist aktuell keiner Schicht zugeteilt!
      br
      br
      span(v-if="user.can_apply_for_shifts") Checke Deine
      br

    a.button(@click="switchToApplications()",
             v-if="user.can_apply_for_shifts") Bewerbungen

</template>

<script>
export default {
  name: 'shifts',
  props: ['switchToApplications', 'user'],
  data () {
    return {
      days: [],
      loading: true
    }
  },
  created () {
     // get shifts
    this.$nextTick(function () {
      let loginToken = this.$parent.loginToken
      if (loginToken !== 'undefined') {
        this.$http.get('/shifts/')
            .set({Authorization: 'jwt ' + loginToken})
            .then(res => (this.days = res.body))
            .catch(err => {
              console.log(err)
              this.$notify.danger('Keine Shichten')
            })
      }
    })
  },
  methods: {
    toggleOtherShifts: function (day) {
      day.show_others = !day.show_others
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">

h3
  font-weight: bold
  margin-top: 10px

.field
  font-weight: bold
  margin-top: 0.5em

  .button-div
    text-align: center

  .other-shifts
    margin: 0px -10px -10px -10px
    padding: 0 10px

.day
  text-align: left
  margin: 1.5em 0
  padding: 10px
  background: rgba(44, 44, 44, 0.06)
  &.gray
    background: rgba(44, 44, 44, 0.15)

.date
  font-weight: bold
  font-size: 23px

dt, dd
  display: inline-block
  font-weight: bold
dt
  width: 80px

.day.is-today
  border-left: 4px solid #ce0400
  padding-left: 10px

.day.is-today:before
  content: 'HEUTE '
  color: #ce0400
  font-weight: bold

.manager + .manager:before
  content: ', '

.manager-label
  font-weight: bold

.files i
  width: 20px
</style>



// WEBPACK FOOTER //
// Shifts.vue?38aa6539